<template>
    <div
        v-if="value"
        :title="type === 'relative' ? $t('messages.can_take_student') : $t('messages.can_leave_by_themselves')"
        class="shrink-0"
    >
        <svg
            class="w-4 h-4 inline-block text-green-300"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                clip-rule="evenodd"
            ></path>
        </svg>
        <svg
            class="w-4 h-4 inline-block text-green-300"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
            ></path>
        </svg>
    </div>
    <div
        v-else
        :title="type === 'relative' ? $t('messages.cannot_take_student') : $t('messages.cannot_leave_by_themselves')"
        class="shrink-0"
    >
        <svg
            class="w-4 h-4 inline-block text-red-300"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                clip-rule="evenodd"
            ></path>
        </svg>
        <svg
            class="w-4 h-4 inline-block text-red-300"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
            ></path>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'CanTakeStudent',
    props: {
        value: {
            required: true,
        },
        type: {
            type: String,
            default: 'relative',
        },
    },
};
</script>
